import aboutImageInfo from "../../assets/images/somos/Frame 60.png";
import styles from "./SectionInfo.module.css";
import { Link } from "react-router-dom";

/**
 * El componente SectionInfo muestra una sección informativa con una imagen y texto superpuesto.
 * Invita a los usuarios a consultar sobre la publicación en las revistas e incluye un botón "Informes".
 *
 * @component
 * @returns {JSX.Element} El componente SectionInfo renderizado.
 */
const SectionInfo = () => {
  return (
    <div className={styles.container}>
      <img
        src={aboutImageInfo}
        alt="Publicación"
        className={styles.image}
        loading="lazy"
      />
      <div className={styles.overlay}>
        ¿Quieres publicarte en nuestras Revistas?
        <div className={styles.button}>
          <Link
            onClick={() => window.scrollTo(0, 0)}
            to="/contacto"
            className={styles.buttonText}
          >
            Informes
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SectionInfo;
